module.exports = __webpack_public_path__ + "img/logo.44408fe2.png";